import { ReactNode } from "react";
import "./Text.scss";

export type TextProps = {
  color?: "primary" | "dark" | "light" | "n-100" | "n-200" | "n-300" | "n-400" | "n-900";
  size?: "xs" | "s" | "m" | "l";
  variant?: "regular" | "medium" | "bold";
  styleText?: "normal" | "italic";
  align?: "start" | "center" | "end";
  marginY?: "m0" | "m0-5" | "m1" | "m2" | "m3" | "m4";
  paddingX?: "p0" | "p1" | "p2" | "p3" | "p4";
  maxWidth?: "full" | "300" | "400";
  children: ReactNode;
  className?: string | string[];
  as?: "p" | "label";
  htmlFor?: string;
  onClick?: () => void;
};

const Text = ({
  as = "p",
  color = "n-900",
  variant = "regular",
  marginY = "m0-5",
  paddingX = "p0",
  size = "m",
  maxWidth="full",
  styleText="normal",
  align,
  children,
  className,
  htmlFor,
  onClick
}: TextProps) => {
  const Tag = as;
  const colorClass = `Text--color-${color}`;
  const sizeClass = `Text--size-${size}`;
  const styleClass = `Text--style-${styleText}`;
  const variantClass = `Text--variant-${variant}`;
  const alignClass = `Text--align-${align}`;
  const marginYClass = marginY ? `Text--margin-y-${marginY}` : undefined;
  const paddingXClass = paddingX ? `Text--padding-x-${paddingX}` : undefined;
  const maxWidthClass = maxWidth ? `Text--max-width-${maxWidth}` : undefined;
  const additionalClasses =
    typeof className === "string" ? className : className?.join(" ");
  const textTagClass = [
    "Text",
    colorClass,
    sizeClass,
    styleClass,
    variantClass,
    marginYClass,
    paddingXClass,
    alignClass,
    maxWidthClass,
    additionalClasses,
  ]
    .filter((el) => el)
    .join(" ");
  return (
    <Tag onClick={onClick} className={textTagClass} {...{ htmlFor }}>
      {children}
    </Tag>
  );
};

export { Text };
